/**
 * ▼▼▼ FloatingCTA Logic (Intersection Observer) ▼▼▼
 * MVが画面外に出たらCTAを表示し、フッターが画面内に入ったら隠す
 * ページ内のCTAセクションが見えている間も隠す
 */
const floatingCta = document.querySelector(".js-floating-cta");
const mvSection = document.querySelector("#mv");
const footer = document.querySelector(".l-footer");

if (floatingCta && mvSection && footer) {
  // 1. MVセクションを監視するObserver
  const mvObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // isIntersectingがfalse = 画面内にMVがなくなった
        if (!entry.isIntersecting) {
          floatingCta.classList.add("is-visible");
        } else {
          floatingCta.classList.remove("is-visible");
        }
      });
    },
    {
      rootMargin: "0px 0px 0px 0px", // 画面の上端を基準にする
      threshold: 0,
    },
  );
  mvObserver.observe(mvSection);

  // 2. フッターを監視するObserver
  const footerObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // isIntersectingがtrue = 画面内にフッターが入ってきた
        if (entry.isIntersecting) {
          floatingCta.classList.add("is-hidden-by-footer");
        } else {
          floatingCta.classList.remove("is-hidden-by-footer");
        }
      });
    },
    {
      rootMargin: "0px",
      threshold: 0,
    },
  );
  footerObserver.observe(footer);

  // 3. ページ内CTAセクション通過時に隠すObserver (全ページ適用)
  // mainタグ内の .c-cta だけを対象にする（ヘッダーやモーダルを除外）
  const sectionCtas = document.querySelectorAll("main .c-button--cta");

  // 現在画面内に見えているCTA要素を管理するSet
  const visibleCtas = new Set();

  const ctaObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 画面内に入ったらSetに追加
          visibleCtas.add(entry.target);
        } else {
          // 画面外に出たらSetから削除
          visibleCtas.delete(entry.target);
        }
      });

      // 1つでも見えているCTAがあれば隠すクラスを付与
      if (visibleCtas.size > 0) {
        floatingCta.classList.add("is-hidden-by-cta");
      } else {
        floatingCta.classList.remove("is-hidden-by-cta");
      }
    },
    {
      rootMargin: "0px", // 必要に応じて調整
      threshold: 0,
    },
  );

  sectionCtas.forEach((cta) => {
    ctaObserver.observe(cta);
  });
}

/**
 * ▼▼▼ Accordion (共通) ▼▼▼
 */
const accordions = document.querySelectorAll(".js-accordion");
accordions.forEach((accordion) => {
  const trigger = accordion.querySelector(".js-accordion-trigger");
  const content = accordion.querySelector(".c-accordion__content");

  if (trigger && content) {
    trigger.addEventListener("click", () => {
      // is-openクラスを付け替え
      accordion.classList.toggle("is-open");

      if (accordion.classList.contains("is-open")) {
        // 開くとき：コンテンツの本来の高さを取得して適用
        content.style.height = `${content.scrollHeight}px`;
      } else {
        // 閉じるとき：高さを0に戻す
        content.style.height = "0px";
      }
    });
  }
});

// ウィンドウリサイズ時に、開いているアコーディオンの高さを再計算
window.addEventListener("resize", () => {
  document.querySelectorAll(".js-accordion.is-open").forEach((openAccordion) => {
    const content = openAccordion.querySelector(".c-accordion__content");
    // 一度高さをautoに戻してscrollHeightを再取得し、再度高さを設定
    content.style.height = "auto";
    content.style.height = `${content.scrollHeight}px`;
  });
});

/**
 * ▼▼▼ Copy Button ▼▼▼
 */
const copyButtons = document.querySelectorAll(".js-copy-button");
copyButtons.forEach((button) => {
  const originalText = button.textContent;
  button.addEventListener("click", (e) => {
    // 既にコピー済みの場合は何もしない
    if (button.classList.contains("is-copied")) {
      return;
    }

    const textToCopy = e.currentTarget.dataset.copyText;
    if (textToCopy) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          button.textContent = "コピー済み";
          button.classList.add("is-copied");

          setTimeout(() => {
            button.textContent = originalText;
            button.classList.remove("is-copied");
          }, 10000);
        })
        .catch((err) => {
          console.error("Copy failed:", err);
          alert("コピーに失敗しました");
        });
    }
  });
});

/**
 * ▼▼▼ Modal (共通) ▼▼▼
 */
const modalTriggers = document.querySelectorAll(".js-modal-trigger");
const menuButton = document.querySelector(".l-header__menu-button");

const openModal = (modalId) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");

    // もし開いたモーダルがメニューなら、ハンバーガーボタンをアクティブにする
    if (modal.id === "modal-menu" && menuButton) {
      menuButton.classList.add("is-active");
      menuButton.classList.add("is-on-top");
    }
  }
};

const closeModal = (modal) => {
  if (modal) {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");

    // もし閉じたモーダルがメニューなら、ハンバーガーボタンを元に戻す
    if (modal.id === "modal-menu" && menuButton) {
      menuButton.classList.remove("is-active");
      menuButton.classList.remove("is-on-top");
    }
  }
};

modalTriggers.forEach((trigger) => {
  trigger.addEventListener("click", (e) => {
    e.preventDefault();

    // クリックされたのがメニューボタンで、かつ既にアクティブ（開いている）場合
    if (e.currentTarget === menuButton && menuButton.classList.contains("is-active")) {
      // メニューモーダルを閉じる
      const menuModal = document.getElementById("modal-menu");
      closeModal(menuModal);
    } else {
      // それ以外の場合は、通常通りモーダルを開く
      const modalId = e.currentTarget.dataset.modalTarget.substring(1);
      openModal(modalId);
    }
  });
});

document.addEventListener("click", (e) => {
  if (e.target.matches("[data-modal-close]")) {
    const modal = e.target.closest(".c-modal");
    closeModal(modal);
  }
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    const openModal = document.querySelector(".c-modal.is-open");
    closeModal(openModal);
  }
});

/**
 * ▼▼▼ External Link Confirmation Modal ▼▼▼
 */
const externalLinkModal = document.getElementById("modal-external-link");

// ★モーダルがページ内に存在する場合のみ実行（afではHTMLがないため実行されない＝通常遷移になる）
if (externalLinkModal) {
  // 1. ページ内のすべての target="_blank" リンクを取得 (モーダル内のリンクは除く)
  const externalLinks = document.querySelectorAll('a[target="_blank"]:not([data-modal-close]):not(#external-link-proceed):not(.c-button--cta)');
  const externalLinkProceedButton = document.getElementById("external-link-proceed");

  // 2. 各リンクにクリックイベントリスナーを追加
  externalLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      // 3. デフォルトのリンク遷移を一旦停止
      event.preventDefault();

      // 4. クリックされたリンクのURLを取得
      const originalUrl = this.href;

      // 5. モーダル内の「続ける」ボタンにURLを設定
      if (externalLinkProceedButton) {
        externalLinkProceedButton.href = originalUrl;
      }

      // 6. モーダルを表示する (既存のopenModal関数を再利用)
      openModal("modal-external-link");
    });
  });

  // モーダル内の「続ける」ボタンがクリックされたら、モーダルを閉じる
  if (externalLinkProceedButton) {
    externalLinkProceedButton.addEventListener("click", () => {
      closeModal(externalLinkModal);
    });
  }
}

/**
 * ▼▼▼ Back to Menu Button Logic ▼▼▼
 */
const backToMenuBtn = document.querySelector(".js-back-to-menu");
const inpageNavSection = document.querySelector("#inpage-nav");

if (backToMenuBtn && inpageNavSection) {
  const handleBackToMenuScroll = () => {
    const navBottomPos = inpageNavSection.offsetTop + inpageNavSection.offsetHeight;

    if (window.scrollY > navBottomPos) {
      backToMenuBtn.classList.add("is-visible");
    } else {
      backToMenuBtn.classList.remove("is-visible");
    }
  };

  window.addEventListener("scroll", handleBackToMenuScroll, { passive: true });

  backToMenuBtn.addEventListener("click", () => {
    inpageNavSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });
}

/**
 * ▼▼▼ Tab Panel (タブのグループ化可能) ▼▼▼
 */
const tabPanels = document.querySelectorAll(".js-tab-panel");
tabPanels.forEach((panel) => {
  const triggers = panel.querySelectorAll(".js-tab-trigger");
  const panes = panel.querySelectorAll(".c-tab-panel__pane");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault(); // buttonタグなら不要ですが念のため
      const currentTrigger = e.currentTarget;
      const targetId = currentTrigger.dataset.tabTarget;

      // グループ名を取得（HTML側で data-tab-group="xxx" を指定）
      const groupName = currentTrigger.dataset.tabGroup;

      if (!targetId) return;

      // --- グループによる絞り込み ---

      // 1. 操作対象とするトリガー（ボタン）を決定
      const targetTriggers = groupName ? Array.from(triggers).filter((t) => t.dataset.tabGroup === groupName) : triggers; // グループ指定がなければ全体を対象

      // 2. 操作対象とするペイン（中身）を決定
      const targetPanes = groupName ? Array.from(panes).filter((p) => p.dataset.tabGroup === groupName) : panes; // グループ指定がなければ全体を対象

      // --- 切り替え処理 ---

      // 対象グループ内のアクティブクラスを削除
      targetTriggers.forEach((t) => t.classList.remove("is-active"));
      targetPanes.forEach((p) => p.classList.remove("is-active"));

      // クリックした要素とターゲットをアクティブ化
      currentTrigger.classList.add("is-active");

      // ターゲットIDに対応する要素を探してアクティブ化
      const targetPane = document.querySelector(targetId);
      if (targetPane) {
        targetPane.classList.add("is-active");
      }
    });
  });
});

/**
 * data属性 `data-mh-group` ごとに要素の高さを揃える
 * スマホ対応版: `data-mh-sp="true"` が指定されたグループはブレークポイント以下でも高さを揃える
 * @param {string} selector - 対象要素の共通セレクタ (例: '.js-match-height')
 * @param {number} breakpoint - PC/スマホのブレークポイント (これ以下の幅をスマホビューとする)
 */
function matchHeightByGroup(selector = ".js-match-height", breakpoint = 767.9) {
  const elements = document.querySelectorAll(selector);
  if (elements.length === 0) return;

  const windowWidth = window.innerWidth;

  // グループを格納するオブジェクト
  // { groupName: { elements: [el1, el2], matchOnSp: false } }
  const groups = {};

  // 1. 要素をグループ分けする
  elements.forEach((el) => {
    const groupName = el.dataset.mhGroup;
    if (!groupName) return;

    if (!groups[groupName]) {
      groups[groupName] = {
        elements: [], // グループに属する要素
        matchOnSp: false, // スマホでも揃えるか
      };
    }
    groups[groupName].elements.push(el);

    // グループ内のどれか一つでも 'data-mh-sp="true"' を持っていれば
    // そのグループはスマホでも高さを揃える
    if (el.dataset.mhSp === "true") {
      groups[groupName].matchOnSp = true;
    }
  });

  // 2. グループごとに高さを処理
  for (const groupName in groups) {
    const groupElements = groups[groupName].elements;
    const matchOnSp = groups[groupName].matchOnSp;

    // 高さを揃えるべきか判断
    const shouldMatchHeight =
      windowWidth > breakpoint || // 1. PCビューの場合
      (windowWidth <= breakpoint && matchOnSp); // 2. スマホビューだが、matchOnSpがtrueの場合

    if (shouldMatchHeight) {
      // --- 高さ揃え実行 ---

      let maxHeight = 0;

      // 2a. まず高さをリセット (リサイズで縮んだ場合に対応)
      groupElements.forEach((el) => {
        el.style.height = "auto";
      });

      // 2b. グループ内の最大高さを取得
      groupElements.forEach((el) => {
        if (el.offsetHeight > maxHeight) {
          maxHeight = el.offsetHeight;
        }
      });

      // 2c. グループの全要素に最大高さを適用
      groupElements.forEach((el) => {
        el.style.height = `${maxHeight}px`;
      });
    } else {
      // --- 高さリセット (スマホビューで揃えない場合) ---

      // 2d. 高さをリセット
      groupElements.forEach((el) => {
        el.style.height = "auto";
      });
    }
  }
}

/**
 * debounce（間引き）関数
 * @param {function} func - 実行したい関数
 * @param {number} wait - 待機時間 (ms)
 */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// --- 実行 ---

// 1. 実行する関数（セレクタとブレークポイントを指定）
const handleResize = debounce(() => {
  // ブレークポイント 767px (これ以下をスマホビューとする)
  matchHeightByGroup(".js-match-height", 767);
}, 100);

// 2. イベントリスナーを設定
// ページの初回読み込み時
window.addEventListener("DOMContentLoaded", handleResize);
// ウィンドウのリサイズ時
window.addEventListener("resize", handleResize);
// (フォント読み込みや画像読み込み完了後にも実行したい場合)
window.addEventListener("load", handleResize);

/**
 * ▼▼▼ Copyright Year Update ▼▼▼
 */
const copyrightElement = document.querySelector(".l-footer__copyright");
if (copyrightElement) {
  const currentYear = new Date().getFullYear();
  copyrightElement.textContent = copyrightElement.textContent.replace("2025", currentYear);
}

/**
 * ▼▼▼ Scroll to Section and Open Accordion ▼▼▼
 */
const scrollAndOpenTriggers = document.querySelectorAll(".js-scroll-and-open");

scrollAndOpenTriggers.forEach((trigger) => {
  trigger.addEventListener("click", function (e) {
    e.preventDefault(); // デフォルトのページ内ジャンプをキャンセル

    const targetAccordionId = this.dataset.accordionTarget;
    const targetAccordion = document.querySelector(targetAccordionId);

    // href属性からスクロール先のセクションIDを取得
    const targetSectionId = this.getAttribute("href");
    const targetSection = document.querySelector(targetSectionId);

    if (!targetSection) return;

    // スムーススクロールを実行
    targetSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    // もし開くべきアコーディオンが指定されていれば、開く処理を追加
    if (targetAccordion) {
      // スクロールが終わったタイミングでアコーディオンを開くための処理
      let scrollTimeout;

      const scrollEndListener = () => {
        // スクロールイベントが止まったらタイマーをクリア
        clearTimeout(scrollTimeout);
        // 200ミリ秒後に新しいタイマーを設定
        scrollTimeout = setTimeout(() => {
          // アコーディオンを開く処理
          const content = targetAccordion.querySelector(".c-accordion__content");
          if (content && !targetAccordion.classList.contains("is-open")) {
            targetAccordion.classList.add("is-open");
            content.style.height = `${content.scrollHeight}px`;
          }
          // 一度実行したら、このリスナーは不要なので削除
          window.removeEventListener("scroll", scrollEndListener);
        }, 200); // スクロール終了の判定時間
      };

      window.addEventListener("scroll", scrollEndListener);
    }
  });
});

/**
 * ▼▼▼ Countdown Timer ▼▼▼
 */
function initCountdown() {
  // ターゲット要素を取得
  const countdownElement = document.getElementById("countdown");
  if (!countdownElement) {
    return; // 要素がなければ何もしない
  }

  // 1. クーポン終了日時を設定
  const limitDate = new Date("2026/02/24 09:59:59");

  // ゼロ埋め用のヘルパー関数
  const addZero = (n) => String(n).padStart(2, "0");

  let timer;

  const updateCountdown = () => {
    const now = new Date();
    // 残り時間をミリ秒で計算
    const remainingTime = limitDate.getTime() - now.getTime();

    // 2. 終了後の処理 (残り時間が0以下になったら)
    if (remainingTime <= 0) {
      clearInterval(timer);
      countdownElement.innerHTML = "終了まであと <strong>00</strong><span>時間</span><strong>00</strong><span>分</span><strong>00</strong><span>秒</span>";
      // もし特定の要素を隠したい場合は、ここに追加
      // document.querySelector('.p-coupon').style.display = 'none';
      return;
    }

    // ミリ秒を日、時間、分、秒に変換
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    //const milliseconds = Math.floor((remainingTime % 1000) / 10); //ミリ秒（2桁）設定用

    // HTMLを描画
    let html = "終了まであと ";
    if (days > 0) {
      html += `<strong>${days}</strong><span>日</span>`;
    }
    html += `<strong>${addZero(hours)}</strong><span>時間</span>`;
    html += `<strong>${addZero(minutes)}</strong><span>分</span>`;
    html += `<strong>${addZero(seconds)}</strong><span>秒</span>`;
    //html += `<strong>${addZero(milliseconds)}</strong>`; //ミリ秒（2桁）設定用

    countdownElement.innerHTML = html;
  };

  timer = setInterval(updateCountdown, 50);

  // 最初に一度実行して、表示のタイムラグをなくす
  updateCountdown();
}

// ページが読み込まれたらカウントダウンを開始
initCountdown();
